export default __webpack_public_path__ + "8524024a0ab665a81ca6f07240ec4926.png";